import React from "react";
import {
    FormRights
} from '../Form/FormComponents'

const Footer = ({theme}) => (
    <FormRights theme={theme}>© Designed and built by Chakib Sennoussi</FormRights>
)

export default Footer